<template>
  <div class="template-auth">
    <div class="main">
      <div class="slot-wrapper">
        <img
          width="187"
          class="pb-5"
          src="@/assets/images/zeus/zeus_full.svg"
        />
        <slot />
      </div>
    </div>
    <div class="bg-zeus"></div>
  </div>
</template>

<script>
export default {
  name: "TemplateAuth"
};
</script>

<style lang="scss" scoped>
.template-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  display: flex;
  .main {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
  .bg-zeus {
    height: 100vh;
    background: url("~@/assets/images/backgrounds/login.svg") no-repeat center
      center;
    background-size: cover;
    flex: 1;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  .slot-wrapper {
    display: flex;
    align-items: center;
    height: fit-content;
    width: 40vw;
    max-width: 438px;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 768px) {
      width: 90vw;
    }

    ::v-deep .form-group {
      .form-control {
        border-radius: 12px;
        background-color: transparent;
        border: 1px solid #0000001a;
        transition: border 0.3s ease;

        &::placeholder {
          transition: color 0.3s ease;
        }

        &::-webkit-input-placeholder {
          transition: color 0.3s ease;
        }

        &::-moz-placeholder {
          transition: color 0.3s ease;
        }

        &:-ms-input-placeholder {
          transition: color 0.3s ease;
        }
        color: #000000;

        &:hover {
          border: 1px solid #00000054;

          &::placeholder {
            color: #000000a3;
          }

          &::-webkit-input-placeholder {
            color: #000000a3;
          }

          &::-moz-placeholder {
            color: #000000a3;
          }

          &:-ms-input-placeholder {
            color: #000000a3;
          }
        }

        &::placeholder {
          color: #00000066;
          opacity: 1;
        }

        &::-webkit-input-placeholder {
          color: #00000066;
        }

        &::-moz-placeholder {
          color: #00000066;
          opacity: 1;
        }

        &:-ms-input-placeholder {
          color: #00000066;
        }
      }
      i {
        color: #00000066;
      }
    }
    ::v-deep {
      .animate-right {
        transition: transform 0.3s ease;

        &:hover {
          transform: translateX(6px);
        }
      }

      .animate-left {
        transition: transform 0.3s ease;

        &:hover {
          transform: translateX(-6px);
        }
      }

      h2 {
        color: #000000;
      }

      form {
        width: 100%;
        display: flex;
        flex-direction: column;
      }
      a {
        color: #f78012;

        &:hover {
          text-decoration: none;
        }
      }

      p {
        color: #00000066;
        font-size: 14px;
      }

      .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        gap: 8px;
        width: 100%;
        padding: 8px 16px;
        border-radius: 12px;
        min-height: 40px;
        background-color: #162f54;
        border: 1px solid rgba(30, 96, 255, 0.35);
        color: white;
        font-weight: 600;
        line-height: 1.2;
        transition: background-color 0.3s ease, border-color 0.3s ease,
          color 0.3s ease, opacity 0.3s ease;
        cursor: pointer;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
      }

      .btn:hover:not(:disabled) {
        background-color: gray;
        border-color: gray;
      }

      .btn:active:not(:disabled) {
        background-color: rgba(30, 96, 255, 0.28);
        border-color: rgba(30, 96, 255, 0.55);
      }

      .btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      .btn.loading {
        pointer-events: none;
      }

      .spinner {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid rgba(30, 96, 255, 0.15);
        border-top-color: white;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
}
</style>
